import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { UserInterface, setEditId, setEditError, selectUserById } from "../../../store/mine_craft/usersSlice";
import { updateUser, fetchUser } from "../../../actions/mine_craft/usersActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.mineCraft.users.editId);
  const error   = useAppSelector(state => state.mineCraft.users.editError);
  const comment = useAppSelector(state => selectUserById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchUser(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: UserInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: UserInterface) {
    const formData = objToFormData(data);
    const resultAction = await dispatch(updateUser({ id, data: formData }));

    if (updateUser.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-comment'>
        <h6 className="v-content-label">Edit User</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={comment} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
